"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterdayInterval = exports.IntradayInterval = void 0;
var IntradayInterval;
(function (IntradayInterval) {
    IntradayInterval["ONE_MINUTE"] = "PT1M";
    IntradayInterval["FIVE_MINUTES"] = "PT5M";
    IntradayInterval["TEN_MINUTES"] = "PT10M";
    IntradayInterval["THIRTY_MINUTES"] = "PT30M";
    IntradayInterval["SIXTY_MINUTES"] = "PT60M";
    IntradayInterval["ONE_HOUR"] = "PT1H";
})(IntradayInterval || (exports.IntradayInterval = IntradayInterval = {}));
var InterdayInterval;
(function (InterdayInterval) {
    InterdayInterval["DAILY"] = "P1D";
    InterdayInterval["SEVEN_DAYS"] = "P7D";
    InterdayInterval["WEEKLY"] = "P1W";
    InterdayInterval["MONTHLY"] = "P1M";
    InterdayInterval["QUARTERLY"] = "P3M";
    InterdayInterval["TWELVE_MONTHS"] = "P12M";
    InterdayInterval["YEARLY"] = "P1Y";
})(InterdayInterval || (exports.InterdayInterval = InterdayInterval = {}));
